export default function alwaysNull(): null {
  return null
}